var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorchecking = function SvgErrorchecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 54
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "errorchecking_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292485",
    d: "M.596 24.81 13.871 2.19A4.46 4.46 0 0 1 17.725 0h26.55c1.59 0 3.059.834 3.854 2.19l13.275 22.62a4.32 4.32 0 0 1 0 4.38L48.129 51.81A4.46 4.46 0 0 1 44.275 54h-26.55a4.46 4.46 0 0 1-3.854-2.19L.596 29.19a4.32 4.32 0 0 1 0-4.38"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#errorchecking_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#586193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.443 30.665a9.42 9.42 0 0 1-6.68-2.762c-3.684-3.684-3.684-9.679 0-13.362 3.683-3.684 9.68-3.684 13.361 0a9.48 9.48 0 0 1 1.9 10.638.586.586 0 1 1-1.066-.492 8.31 8.31 0 0 0-1.666-9.314c-3.223-3.225-8.473-3.225-11.698 0s-3.224 8.473 0 11.698 8.473 3.224 11.698 0a.588.588 0 1 1 .832.832 9.42 9.42 0 0 1-6.68 2.762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.554 42.363a3 3 0 0 1-2.14-.887l-6.539-6.537a.588.588 0 1 1 .832-.832l6.539 6.537c.699.7 1.92.7 2.619 0 .352-.35.544-.816.544-1.31 0-.496-.192-.962-.544-1.31l-6.535-6.539c-.7-.699-1.922-.7-2.623 0a.603.603 0 0 1-.832 0l-3.582-3.582a.588.588 0 0 1 .83-.832l3.21 3.207a3 3 0 0 1 1.685-.51c.808 0 1.571.314 2.142.887l6.537 6.537c.572.572.889 1.331.889 2.142 0 .809-.317 1.57-.89 2.142-.57.573-1.33.887-2.142.887M28.563 24.93c-.15 0-.3-.059-.416-.172l-6.237-6.24a.588.588 0 1 1 .832-.832l6.238 6.24a.588.588 0 0 1-.416 1.004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.324 24.93a.59.59 0 0 1-.415-1.004l6.237-6.24a.59.59 0 0 1 .834.832l-6.24 6.24a.6.6 0 0 1-.416.172"
  }))))));
};
export default SvgErrorchecking;